'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VisibilityLabel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _constantsList = require('@bibliocommons/constants-list');

var _visibilityIcon = require('../../visibility-icon');

var _visibilityIcon2 = _interopRequireDefault(_visibilityIcon);

var _localeLabel = require('../../locale-label');

var _localeLabel2 = _interopRequireDefault(_localeLabel);

require('../styles/VisibilityLabel.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getVisibilityText = function getVisibilityText(visibility, localeLabel) {
  if (visibility === _constantsList.VISIBILITY.GEOFENCED) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'user_list_visibility_geofenced_with_location',
      values: { location: localeLabel } });
  }

  return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_visibility_' + visibility });
};

function VisibilityLabel(_ref) {
  var visibility = _ref.visibility,
      locale = _ref.locale,
      possibleLocales = _ref.possibleLocales;

  var localeLabel = _react2.default.createElement(_localeLabel2.default, { locale: locale, possibleLocales: possibleLocales });

  return _react2.default.createElement(
    'span',
    { className: 'cp-visibility-label' },
    _react2.default.createElement(_visibilityIcon2.default, { visibility: visibility }),
    getVisibilityText(visibility, localeLabel)
  );
}

VisibilityLabel.propTypes = {
  visibility: _react.PropTypes.string,
  locale: _react.PropTypes.string,
  possibleLocales: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string)
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-label/components/VisibilityLabel.component.js
// module id = 1350
// module chunks = 0